export class SignatureComponentController {
  static $inject = [];

  marked: boolean = false;
}
